import { axios_instance } from './index';

export async function get() {
  return axios_instance.get(`system_setting/`);
}

export const settingService = {
  get,
};
